import React from "react";
import PropTypes from "prop-types";
import ReadOnlyField from "./ReadOnlyField";

const PatternSystemView = ({
  documentCategoryText,
  productNo,
  destination,
  customer,
  issueDate,
  assignee,
  deviceName,
  assemblyType,
  remarks,
}) => {
  const renderSelect = (label, text) => (
    <div className="form-row">
      <span className="form-label">{label}</span>
      <div className="form-value read-only-select">
        <select className="form-select" disabled>
          <option value="">{text || ""}</option>
        </select>
      </div>
    </div>
  );

  return (
    <div className="pattern-form">
      <div className="form-grid pattern-system-grid">
        <ReadOnlyField label="製番" value={productNo} />
        {renderSelect("図面種類（システム装置）", documentCategoryText)}
        <ReadOnlyField label="仕向先" value={destination} />
        <ReadOnlyField label="日付" value={issueDate} />
        <ReadOnlyField label="得意先" value={customer} />
        <ReadOnlyField label="担当者" value={assignee} />
        <ReadOnlyField label="設備名" value={deviceName} />
        <ReadOnlyField label="備考" value={remarks} />
        <ReadOnlyField label="組立種類" value={assemblyType} />
      </div>
    </div>
  );
};
PatternSystemView.propTypes = {
  documentCategoryText: PropTypes.string,
  productNo: PropTypes.string,
  destination: PropTypes.string,
  customer: PropTypes.string,
  issueDate: PropTypes.string,
  assignee: PropTypes.string,
  deviceName: PropTypes.string,
  assemblyType: PropTypes.string,
  remarks: PropTypes.string,
};

PatternSystemView.defaultProps = {
  documentCategoryText: "",
  productNo: "",
  destination: "",
  customer: "",
  issueDate: "",
  assignee: "",
  deviceName: "",
  assemblyType: "",
  remarks: "",
};

export default PatternSystemView;
